import React, {useState} from "react";
import {Button, Input, ModalBody, ModalFooter, ModalHeader, Spinner} from "reactstrap";
import {useAppContext} from "../../hooks";
import {postJsonAxiosService} from "../../services/callAxios";
import {toastService} from "../../services/toast.service";

const GreenhouseModal = (props) => {
    const {user} = useAppContext();
    const {provider, toggle} = props;
    const [apiKey, setApiKey] = useState("");
    const [errorApiKey, setErrorApiKey] = useState(false);
    const [subdomain, setSubdomain] = useState("");
    const [errorSubdomain, setErrorSubdomain] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        // Reset error states
        setErrorApiKey(false);
        setErrorSubdomain(false);

        // Validate inputs
        if (!apiKey.trim()) {
            setErrorApiKey(true);
            return;
        }
        if (!subdomain.trim()) {
            setErrorSubdomain(true);
            return;
        }

        // Create provider object
        let provider = {
            accessToken: apiKey.trim(),
            providerId: subdomain.trim(),
            provider: "greenhouse",
            service: "ats",
            url: `https://${subdomain.trim()}.greenhouse.io`
        }

        try {
            setLoading(true);
            let response = await postJsonAxiosService("greenhouse/webhook/validate", {provider: provider});
            setLoading(false);
            
            if (response) {
                if (!user.providers || user.providers.length === 0) {
                    user.providers = [];
                }
                toastService.info("Greenhouse ATS Integrated Successfully");
                window.location.reload();
            }
        } catch (e: any) {
            setLoading(false);
            const errorMessage = e.response?.data?.error || "Error while updating Greenhouse integration";
            toastService.error(errorMessage);
        }
    };

    return (
        <div style={{padding: 20}}>
            <ModalHeader toggle={props.toggle}
                         style={{fontSize: 24, fontWeight: 600, border: "none"}}>
                <span>Add Greenhouse ATS Integration</span>
            </ModalHeader>
            <ModalBody>
                <div>
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124"}}>
                        <label>API Key</label>
                        <Input 
                            style={{fontSize: 14, color: "#202124"}}
                            placeholder="Enter your Greenhouse API Key"
                            value={apiKey}
                            onChange={(e) => {
                                setApiKey(e.target.value);
                                setErrorApiKey(false);
                            }}
                            invalid={errorApiKey}
                        />
                        {errorApiKey && (
                            <div style={{color: "red", fontSize: 12, marginTop: 5}}>
                                API Key is required
                            </div>
                        )}
                        <div style={{fontSize: 12, color: "#666", marginTop: 5}}>
                            You can find your API key in Greenhouse under Configure → Dev Center → API Credential Management
                        </div>
                    </div>
                    
                    <div className="snippet-desc" style={{fontSize: 14, color: "#202124", marginTop: 20}}>
                        <label>Subdomain</label>
                        <Input 
                            style={{fontSize: 14, color: "#202124"}}
                            placeholder="yourcompany (without .greenhouse.io)"
                            value={subdomain}
                            onChange={(e) => {
                                setSubdomain(e.target.value);
                                setErrorSubdomain(false);
                            }}
                            invalid={errorSubdomain}
                        />
                        {errorSubdomain && (
                            <div style={{color: "red", fontSize: 12, marginTop: 5}}>
                                Subdomain is required
                            </div>
                        )}
                        <div style={{fontSize: 12, color: "#666", marginTop: 5}}>
                            Enter your Greenhouse subdomain (e.g., if your URL is "acme.greenhouse.io", enter "acme")
                        </div>
                    </div>

                    <div style={{fontSize: 12, color: "#666", marginTop: 20, padding: 15, backgroundColor: "#f8f9fa", borderRadius: 5}}>
                        <strong>Instructions:</strong>
                        <ol style={{marginTop: 10, paddingLeft: 20}}>
                            <li>Log into your Greenhouse account</li>
                            <li>Go to Configure → Dev Center → API Credential Management</li>
                            <li>Create a new API key with appropriate permissions</li>
                            <li>Copy the API key and enter it above</li>
                            <li>Enter your company's Greenhouse subdomain</li>
                        </ol>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter style={{border: "none", paddingTop: 0}}>
                <Button
                    className={"btn-typography-primary"}
                    onClick={handleSubmit}
                    disabled={loading}
                    style={{fontSize: 14, fontWeight: 600}}
                >
                    {loading ? (
                        <>
                            <Spinner size="sm" style={{marginRight: 8}} />
                            Integrating...
                        </>
                    ) : (
                        "Add Integration"
                    )}
                </Button>
                <Button
                    className={"btn-typography-secondary"}
                    onClick={toggle}
                    disabled={loading}
                    style={{fontSize: 14, fontWeight: 600}}
                >
                    Cancel
                </Button>
            </ModalFooter>
        </div>
    );
};

export default GreenhouseModal;
